import React from 'react';
import type { PolymorphicComponent } from 'react-polymorphed';
import { useLocalizedPriceFormatter } from 'tradera/localization/use-localized-price-formatter';

export type PriceLabelProps = {
    price?: number;
    hasDiscount?: boolean;
    renderZero?: boolean;
    className?: string;
};

export const PriceLabel: PolymorphicComponent<'span', PriceLabelProps> = ({
    as: Component = 'span',
    className,
    price,
    hasDiscount,
    renderZero,
    ...props
}) => {
    const localizedPriceFormatter = useLocalizedPriceFormatter();

    if (!price && !(renderZero && price === 0)) {
        return null;
    }

    const formattedPrice = localizedPriceFormatter(price);

    return formattedPrice ? (
        <Component className={className} {...props}>
            {formattedPrice}
        </Component>
    ) : null;
};
